<template>
  <div class="container mt-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2>Customers</h2>
      <!-- "Add New Customer" Button aligned to the right -->
    </div>
    <div class="mb-4">
      <router-link to="/add-customer" class="btn btn-primary"
        >Add New Customer</router-link
      >
    </div>
    <!-- Loading Image -->
    <div v-if="loading" class="d-flex justify-content-center my-4">
      <img src="@/assets/loading.gif" alt="Loading..." class="loading-image" />
    </div>

    <!-- Customer List -->
    <ul v-if="customers.length && !loading" class="list-unstyled">
      <li v-for="customer in customers" :key="customer.email" class="card mb-4">
        <div class="card-body">
          <h3 class="card-title">{{ customer.displayName }}</h3>
          <img
            :src="customer.image"
            alt="Customer image"
            class="customer-image img-thumbnail mb-3 w-25"
          />

          <p class="card-text"><strong>City:</strong> {{ customer.city }}</p>
          <p class="card-text"><strong>Email:</strong> {{ customer.email }}</p>
          <p class="card-text">
            <strong>Balance Due:</strong> {{ customer.balanceDue }}
            {{ customer.currencyCode }}
          </p>
          <p class="card-text">
            <strong>Last Modified:</strong> {{ customer.lastModifiedDateTime }}
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { logout } from "@/helper/utils1"; // Use `@` for the src directory
import { getCustomers } from "@/helper/RestCalls";

export default {
  data() {
    return {
      customers: [],
      loading: true,
    };
  },
  async mounted() {
    this.loadCustomers();
  },
  methods: {
    getOauthToken() {
      return localStorage.getItem("token");
    },
    async loadCustomers() {   
      try {
        this.customers = await getCustomers();
      } catch (err) {
        console.log(err);
        if (err.status == 401) {
          logout(this.$router);
        }
      } finally {
        // Hide loading image once data is fetched
        this.loading = false;
      }
    },
  },
};
</script>
